import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'wikileaf-coverletter',
  templateUrl: './wikileaf.coverletter.component.pug',
  styleUrls: ['./wikileaf.coverletter.component.styl']
})
export class CoverletterWikileafComponent implements OnInit {

	public constructor(private titleService: Title) { }
  
	title: string;
	subtitle: string;
	tirtitle: string;
	company: string;

	ngOnInit() {
		this.title='Wikileaf';
		this.subtitle='Human Resources';
		this.titleService.setTitle("Liam Hogan's | Wikileaf | Cover Letter");
		this.tirtitle='';
		this.company='Wikileaf'; 
	}

}
